import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function contactsReducer(state = initialState.contacts , action) {
    if (action.type === types.LOAD_CONTACT_SUCCESS)
    {
        return action.contacts
    }
    else {
        return state;
    }
}
